
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({ name: 'h5-home' })
export default class H5Home extends Vue {
  mounted() {
    document.title = 'H5 首页'
  }
}
